// const path = require('path');
// const { Sitemap } = require('react-router-sitemap'); 
// const routerLinks = require('../../src/routes/AppRoutes'); 
import { Helmet } from "react-helmet-async";


export default function transformCompanyName(companyName) {
  return companyName
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-'); // Replace all spaces with hyphens
}

export const SEOLINK = ({ title, description, image, url , keyword}) => {
  return (
    <Helmet>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={window.location.href} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keyword} />
      
    </Helmet>
  );
};

export const SEOTITLE = ({ title, description , keyword}) => {
  // <SEOLINK title={title} description={description} keyword={keyword}/>
  return (
    <Helmet>
      {/* <SEOComponent title={title} description={description}/> */}

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keyword} />
    </Helmet>
  );
};

export const getFirstTwoWordsWithDash = (text) => {
  return text?.split(" ").slice(0, 2).join(" ") || "";
};

